webpackJsonp([38],{

/***/ "+skl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2FWj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menu_bar',
  data: function data() {
    return {
      menus: null,
      groups: null,
      openMenus: [],
      menuKeys: []
    };
  },
  created: function created() {
    this.getData();
  },

  methods: {
    getData: function getData() {
      var user = Lockr.get('user');
      //console.log(user)
      this.groups = user.group.content.cid;
      //console.log(JSON.stringify(this.groups));
      this.menus = Lockr.get('menus');
      //console.log(JSON.stringify(this.menus));
      for (var key in this.groups) {
        this.menuKeys.push(key);
      }
      this.openMenus.push(this.menuKeys[0]);
    },
    getSelect: function getSelect(e) {
      this.$router.push({ name: this.menus[e].router });
    }
  }
});

/***/ }),

/***/ "LMgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_node_modules_iview_loader_index_js_ref_0_1_App_vue__ = __webpack_require__("eaOS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39cb4608_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_iview_loader_index_js_ref_0_1_App_vue__ = __webpack_require__("QduU");
function injectStyle (ssrContext) {
  __webpack_require__("LMgN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_node_modules_iview_loader_index_js_ref_0_1_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39cb4608_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_iview_loader_index_js_ref_0_1_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview__ = __webpack_require__("BTaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lockr__ = __webpack_require__("RRJN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lockr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lockr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_util__ = __webpack_require__("TVG1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css__ = __webpack_require__("+skl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__ = __webpack_require__("e0XP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_jsonp__ = __webpack_require__("jHlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_amap___ = __webpack_require__("/IwO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_amap____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_amap___);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_amap____default.a);
__WEBPACK_IMPORTED_MODULE_12_vue_amap____default.a.initAMapApiLoader({
  key: '9c8dad04159dca247e6709ec403bd40a',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geocoder', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_iview___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_jsonp__["a" /* VueJsonp */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.baseURL = "https://api.sdzhongyue.com/v2";
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.timeout = 1000 * 15;

window.Lockr = __WEBPACK_IMPORTED_MODULE_6_lockr___default.a;
window.axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;
window.Bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2_iview___default.a.LoadingBar.start();
  __WEBPACK_IMPORTED_MODULE_7__libs_util__["a" /* default */].title(to.meta.title);
  var level = __WEBPACK_IMPORTED_MODULE_7__libs_util__["a" /* default */].level(to.name, __WEBPACK_IMPORTED_MODULE_6_lockr___default.a.get('menus'));
  if (!level && ['Login', 'Home'].indexOf(to.name) == -1) {
    __WEBPACK_IMPORTED_MODULE_2_iview___default.a.Message.error('没有权限，请联系管理员');
    __WEBPACK_IMPORTED_MODULE_2_iview___default.a.LoadingBar.error();
    return true;
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].afterEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2_iview___default.a.LoadingBar.finish();
  window.scrollTo(0, 0);
});

__WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.response.use(function (response) {
  if (!response.data.state) {
    __WEBPACK_IMPORTED_MODULE_2_iview___default.a.Message.error(response.data.error.join('，'));
    __WEBPACK_IMPORTED_MODULE_2_iview___default.a.LoadingBar.error();
  }
  return response;
}, function (error) {
  switch (error.response.status) {
    case 500:
      __WEBPACK_IMPORTED_MODULE_2_iview___default.a.Message.error('服务器内部错误');
      break;
    case 401:
      if (!window.hideLogout) {
        __WEBPACK_IMPORTED_MODULE_2_iview___default.a.Message.warning('登录失效，请重新登录');
        window.hideLogout = true;
      }
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: 'Login' });
      break;
    case 403:
      __WEBPACK_IMPORTED_MODULE_2_iview___default.a.Message.warning('禁止访问');
      break;
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] },
  created: function created() {
    window.axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest'
    };
    if (__WEBPACK_IMPORTED_MODULE_6_lockr___default.a.get('token')) {
      window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_6_lockr___default.a.get('token');
    }
  }
});

/***/ }),

/***/ "QduU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"layout-header"},[_c('h2',{staticClass:"layout-logo"},[_c('router-link',{staticStyle:{"color":"#333"},attrs:{"to":{ name: 'Home' }}},[_vm._v("众悦出行·管理平台")])],1),_vm._v(" "),(_vm.isLogin())?_c('div',{staticClass:"layout-user"},[_c('span',{staticClass:"userinfo"},[_vm._v(_vm._s(_vm.username))]),_vm._v(" "),_c('a',{staticClass:"logout",on:{"click":function($event){return _vm.isLogout()}}},[_vm._v("退出")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"layout-content"},[_c('Row',[(_vm.isLogin())?_c('Col',{staticStyle:{"overflow":"auto"},attrs:{"span":"5"}},[_c('menu-bar')],1):_vm._e(),_vm._v(" "),_c('Col',{staticStyle:{"overflow":"auto"},attrs:{"span":_vm.isLogin() ? '19' : '25'}},[_c('div',{staticClass:"layout-content-main"},[_c('router-view')],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"layout-copy"},[_vm._v("\n    "+_vm._s(_vm.getYear())+" © 众悦出行 鲁ICP备19000164号-1\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TVG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  defaultTitle: '众悦出行管理平台',
  title: function title(_title) {
    _title = _title ? _title + ' - ' + this.defaultTitle : this.defaultTitle;
    window.document.title = _title;
  },
  level: function level(router_name, menus) {
    var levelState = false;
    for (var key in menus) {
      if (menus[key].router == router_name) levelState = true;
    }

    return levelState;
  }
});

/***/ }),

/***/ "UBSi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Menu',{attrs:{"width":"auto","accordion":true,"open-names":_vm.openMenus},on:{"on-select":_vm.getSelect}},_vm._l((_vm.groups),function(g,i){return (_vm.menus[i].is_show)?_c('Submenu',{key:i,attrs:{"name":i}},[_c('template',{slot:"title"},[_c('i',{class:("fa " + (_vm.menus[i].icon))}),_vm._v("\n      "+_vm._s(_vm.menus[i].name)+"\n    ")]),_vm._v(" "),_vm._l((g),function(c){return (_vm.menus[c].is_show)?_c('MenuItem',{key:c,attrs:{"name":c}},[_vm._v(_vm._s(_vm.menus[c].name))]):_vm._e()})],2):_vm._e()}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    meta: {
      'title': '使用说明'
    },
    name: 'Home',
    component: function component() {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "lO7g"));
    }
  }, {
    path: '/login',
    meta: {
      'title': '登录'
    },
    name: 'Login',
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "C+Wl"));
    }
  }, {
    path: '/menu/list',
    meta: {
      'title': '菜单管理'
    },
    name: 'MenuList',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "5qe5"));
    }
  }, {
    path: '/group/list',
    meta: {
      'title': '权限管理'
    },
    name: 'GroupList',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "i4Ay"));
    }
  }, {
    path: '/edit-password',
    meta: {
      'title': '修改密码'
    },
    name: 'EditPassword',
    component: function component() {
      return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "dLXl"));
    }
  }, {
    path: '/manager/list',
    meta: {
      'title': '管理员管理'
    },
    name: 'ManagerList',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "sad8"));
    }
  }, {
    path: '/setting/list',
    meta: {
      'title': '参数配置'
    },
    name: 'SettingList',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "v4NH"));
    }
  }, {
    path: '/setting-refund',
    meta: {
      'title': '退款信息配置'
    },
    name: 'SettingRefund',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "RX5d"));
    }
  }, {
    path: '/banner/list',
    meta: {
      'title': '广告位管理'
    },
    name: 'BannerList',
    component: function component() {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "hAQy"));
    }
  }, {
    path: '/charge/list',
    meta: {
      'title': '充值设置'
    },
    name: 'ChargeList',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "nxQi"));
    }
  }, {
    path: '/intro/list',
    meta: {
      'title': '内容管理'
    },
    name: 'IntroList',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "IqE4"));
    }
  }, {
    path: '/car/list',
    meta: {
      'title': '车辆管理'
    },
    name: 'CarList',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "Q3u2"));
    }
  }, {
    path: '/driver/list',
    meta: {
      'title': '司机管理'
    },
    name: 'DriverList',
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "AYMM"));
    }
  }, {
    path: '/feedback/list',
    meta: {
      'title': '投诉反馈'
    },
    name: 'FeedbackList',
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "YTF7"));
    }
  }, {
    path: '/notice/list',
    meta: {
      'title': '通知公告'
    },
    name: 'NoticeList',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "kwnk"));
    }
  }, {
    path: '/content/list',
    meta: {
      'title': '帮助中心'
    },
    name: 'ContentList',
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "WRzR"));
    }
  }, {
    path: '/block/list',
    meta: {
      'title': '首页模块管理'
    },
    name: 'BlockList',
    component: function component() {
      return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "MLbJ"));
    }
  }, {
    path: '/member/list',
    meta: {
      'title': '会员列表'
    },
    name: 'MemberList',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "wNRe"));
    }
  }, {
    path: '/member/visit-list',
    meta: {
      'title': '用户回访'
    },
    name: 'MemberVisitList',
    component: function component() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "Etl8"));
    }
  }, {
    path: '/coupon/list',
    meta: {
      'title': '优惠券列表'
    },
    name: 'CouponList',
    component: function component() {
      return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "qysO"));
    }
  }, {
    path: '/balance/list',
    meta: {
      'title': '充值记录'
    },
    name: 'BalanceList',
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "3AI0"));
    }
  }, {
    path: '/isp/list',
    meta: {
      'title': '服务商列表'
    },
    name: 'IspList',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "EzE7"));
    }
  }, {
    path: '/business/list',
    meta: {
      'title': '商家列表'
    },
    name: 'BusinessList',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "kZU/"));
    }
  }, {
    path: '/business/:id/isp',
    meta: {
      'title': '商家服务商'
    },
    name: 'BusinessIsp',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "4KE9"));
    }
  }, {
    path: '/regular-bus/list',
    meta: {
      'title': '班车列表'
    },
    name: 'RbList',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "VREB"));
    }
  }, {
    path: '/charter-bus/list',
    meta: {
      'title': '包车列表'
    },
    name: 'CbList',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "zaLP"));
    }
  }, {
    path: '/station/list',
    meta: {
      'title': '站点列表'
    },
    name: 'StationList',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "U7+x"));
    }
  }, {
    path: '/busline/list',
    meta: {
      'title': '线路列表'
    },
    name: 'BuslineList',
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "ykxc"));
    }
  }, {
    path: '/busline/:id/station',
    meta: {
      'title': '线路站点'
    },
    name: 'BuslineStation',
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "WcVZ"));
    }
  }, {
    path: '/busline-class/list',
    meta: {
      'title': '班次列表'
    },
    name: 'BuslineClassList',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "LneO"));
    }
  }, {
    path: '/order/busline-list',
    meta: {
      'title': '车票订单列表'
    },
    name: 'OrderBuslineList',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "rPgE"));
    }
  }, {
    path: '/order/ticket-list',
    meta: {
      'title': '车票管理'
    },
    name: 'OrderTicketList',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "/Gip"));
    }
  }, {
    path: '/sms/list',
    meta: {
      'title': '历史短信'
    },
    name: 'SmsList',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "rSKI"));
    }
  }, {
    path: '/booking/list',
    meta: {
      'title': '预约记录'
    },
    name: 'BookingList',
    component: function component() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "t3kE"));
    }
  }, {
    path: '/refund/list',
    meta: {
      'title': '退票改签'
    },
    name: 'RefundList',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "KYcQ"));
    }
  }, {
    path: '/log/list',
    meta: {
      'title': '余额日志'
    },
    name: 'LogBalanceList',
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "6Vtt"));
    }
  }, {
    path: '/black/list',
    meta: {
      'title': '黑名单'
    },
    name: 'BlackList',
    component: function component() {
      return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "o5dE"));
    }
  }]
}));

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eaOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Common_MenuBar__ = __webpack_require__("uOx9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      username: ''
    };
  },

  components: { MenuBar: __WEBPACK_IMPORTED_MODULE_0__components_Common_MenuBar__["a" /* default */] },
  created: function created() {
    if (!Lockr.get('token')) {
      this.$router.replace({ name: 'Login' });
    }
  },

  methods: {
    getNickName: function getNickName() {
      if (Lockr.get('user')) {
        var user = Lockr.get('user');
        this.username = user.name ? user.name : user.username;
      }
    },
    isLogin: function isLogin() {
      this.getNickName();
      return Lockr.get('token') ? true : false;
    },
    getYear: function getYear() {
      var date = new Date();
      return date.getFullYear();
    },
    isLogout: function isLogout() {
      var _this = this;

      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>确定要退出吗？</p>',
        onOk: function onOk() {
          _this.logout();
        }
      });
    },
    logout: function logout() {
      Lockr.flush();
      this.$router.replace({ name: 'Login' });
    }
  }
});

/***/ }),

/***/ "uOx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_node_modules_iview_loader_index_js_ref_0_1_MenuBar_vue__ = __webpack_require__("2FWj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c226dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_iview_loader_index_js_ref_0_1_MenuBar_vue__ = __webpack_require__("UBSi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_node_modules_iview_loader_index_js_ref_0_1_MenuBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07c226dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_iview_loader_index_js_ref_0_1_MenuBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.04bf6a5e296b4455dbe2.js